import { useMemo } from 'react';

/**
 * 获取URLSearchParams参数
 * @param {string} [search] URLSearchParams字符串
 */
export function useSearchParams(search = window.location.search) {
  return useMemo(() => Object.fromEntries(new URLSearchParams(search).entries()), [search]);
}
